export default __webpack_public_path__ + "4b33f3d37c06db49a761e440c56de170.eot";